<table class="details col-12">
  <thead>
    <tr>
      @for (header of headers; track header) {
        <th>{{ header.label || header }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (annuity of data; track annuity) {
      <tr>
        @for (header of headers; track header) {
          <td>{{ annuity[header.label || header] }}</td>
        }
      </tr>
    }
  </tbody>
</table>
